import { useRef } from "react";
import { Reveal, MaskLines } from "../../components/Motion";

const FACTS = [
  ["01", "What it is", "A clear, non-toxic solution of high-purity urea and de-ionised water."],
  ["02", "What it does", "Used in SCR systems to convert harmful NOx emissions into nitrogen and water vapour."],
  ["03", "Who needs it", "BS-VI diesel trucks, buses, tractors and commercial vehicles fitted with SCR."],
];

export default function AboutAdBlue() {
  const ref = useRef(null);

  return (
    <section ref={ref} data-testid="home-adblue-explainer" className="relative overflow-hidden bg-white py-24 md:py-32">
      <div className="mx-auto grid max-w-7xl gap-14 px-5 lg:grid-cols-12 lg:px-8">
        <div className="lg:col-span-5">
          <p className="eyebrow text-brand">The fluid</p>
          <h2 className="mt-4 font-display font-extrabold uppercase leading-[0.85] text-navy">
            <MaskLines inView lines={[{ text: "32.5%", cls: "text-[30vw] sm:text-[11rem] lg:text-[13rem] text-brand" }, { text: "Urea. Zero", cls: "text-5xl md:text-6xl" }, { text: "Compromise.", cls: "text-5xl md:text-6xl" }]} />
          </h2>
        </div>
        <div className="lg:col-span-7 flex flex-col justify-end">
          <div className="relative mb-10 overflow-hidden rounded-[26px] bg-[#2a2163]">
            <img src="/img/real/tata-def-poster.jpg" alt="Tata Motors D.E.F station poster — MHM SUPER ADBLUE" data-testid="home-def-poster" className="mx-auto h-[30rem] md:h-[36rem] w-auto object-contain" />
          </div>
          <div className="divide-y divide-navy/10 border-y border-navy/10">
            {FACTS.map(([n, t, d], i) => (
              <Reveal key={n} delay={i * 0.08}>
                <div className="group grid grid-cols-12 items-baseline gap-4 py-6">
                  <span className="col-span-2 font-mono text-sm text-brand">{n}</span>
                  <h3 className="col-span-10 sm:col-span-4 font-display text-2xl font-bold uppercase text-navy transition-transform duration-500 group-hover:translate-x-2">{t}</h3>
                  <p className="col-span-12 sm:col-span-6 text-slate-600">{d}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
